import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setIsDisabledLiveSiteTranslation: Function // function to toggle custom trigger
}

// component to render widget custom trigger
const LiveSiteTranslation = (props: PropTypes) => {

    // Props
    const { setIsDisabledLiveSiteTranslation } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);
    console.log('currentWebsite: ', currentWebsite);

    // Functions
    const { t } = useTranslation();

    // Stets
    const [customTrigger, setCustomTrigger] = useState<boolean>(false);

    // Set current widget icon type
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if custom trigger is turned On
            if (currentWebsite?.live_site_translate) {
                setCustomTrigger(currentWebsite?.live_site_translate);
            }
        }
    }, [currentWebsite]);



    // set current statement link in prop function
    useEffect(() => {
        setIsDisabledLiveSiteTranslation(customTrigger);
    }, [customTrigger]);

    return (
        <>
            <div className="aioa_dashboard-widget-settings-controls">
                <div className={customTrigger ? "aioa_dashboard-widget-custom-settings" : ''}>
                    <Form.Check
                        type="switch"
                        className="aioa_dashboard-switch"
                        id="custom-trigger-switch"
                        label={`${t('Enable Browser-Based Live Translation')}`}
                        checked={customTrigger}
                        onChange={(e) => setCustomTrigger(!customTrigger)}
                    />
                </div>
            </div>
        </>
    )
}

export default LiveSiteTranslation;